import React from 'react';
import { useDispatch } from 'react-redux';
import { slideAction } from '../../../store/slideSlice';

const SidebarSlideView = ({currentSlideId, slideId, mirrorSlides, ind}) => {
    const dispatch = useDispatch();

    const isSelected = currentSlideId === slideId;

    return (
        <div
            className={isSelected ? "sider-slide-container selectedSlide" : "sider-slide-container"}
            key={slideId}
            onClick={() => dispatch(slideAction.setCurrentSlide(slideId))}
        >
            <span className="slide-number">{String(ind + 1).padStart(2, '0')}</span>
            <div className="sider-slide-wrapper">
                <img
                    data-id={slideId}
                    src={mirrorSlides[slideId]}
                    alt="mirror"
                    className="sider-slide"
                    width='100%'
                    height='100%'
                />
            </div>
        </div>
    );
};

export default React.memo(SidebarSlideView);